import { Switch } from 'antd';
import AntSwitch from './styles/switch.style';

export const IsoSwitch = AntSwitch(Switch);
